import type { Client } from '../../client'
import { createClient } from '../../client'
import type { Explorer } from '../../explorer'
import { createEtherscanV2 } from '../../explorer'
import type { Chain } from '../types/chain'
import type { HttpRpc } from '../types/rpc'
import { hyperEvm } from '../viemChains/hyperEvm'

export const createHyperEvmChain = ({
  explorerApiKey: apiKey,
  explorerProxyUrl: proxyUrl,
  explorerPageSize: pageSize,
}: {
  explorerApiKey?: string
  explorerProxyUrl?: string
  explorerPageSize?: number
}): Chain =>
  createHyperEvmChainCustom({
    client: createClient({ chain: hyperEvm, httpRpcs: hyperEvmHttpRpcs }),
    explorer: createEtherscanV2({
      name: 'HyperEVMScan',
      baseUrl: 'https://hyperevmscan.io',
      chainId: 999,
      apiKey,
      proxyUrl,
      pageSize,
    }),
  })

type CreateHyperEvmChainCustomParameters = {
  client: Client
  explorer: Explorer
}

export const createHyperEvmChainCustom = ({
  client,
  explorer,
}: CreateHyperEvmChainCustomParameters): Chain => ({
  id: 999,
  network: 'hyper-evm',
  name: 'HyperEVM',
  nativeToken: {
    name: 'Hyperliquid',
    symbol: 'HYPE',
    decimals: 18,
    currency: {
      symbol: 'HYPE',
      type: 'CryptoCurrency',
      id: 'hyperliquid',
      name: 'Hyperliquid',
      updatedAt: 0,
    },
  },
  wrappedTokenAddresses: new Set([
    '0x5555555555555555555555555555555555555555',
  ]),
  explorer,
  client,
  blockTime: 1000,
  coingeckoId: 'hyperevm',
  defillamaId: undefined,
})

export const hyperEvmHttpRpcs: HttpRpc[] = [
  {
    url: 'https://rpc.hyperliquid.xyz/evm',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 1000n,
  },
  {
    url: 'https://rpc.hypurrscan.io',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 1000n,
  },
  {
    url: 'https://hyperliquid-json-rpc.stakely.io',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 1000n,
  },
  {
    url: 'https://hyperliquid.drpc.org',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
  {
    url: 'https://rpc.hyperlend.finance',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
]

export const hyperEvmWebsocketRpcUrls: string[] = ['wss://hyperliquid.drpc.org']
